import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import TeamView from '@/components/team/team-view'
import { teamBySlug } from '@/constants/crm'
import { loadCrmPageProps } from '@/lib/crm-page'

type TeamPageProps = Partial<CrmPageProps> & {
    slug: string
}

const TeamPage: FC<TeamPageProps> = ({ data, today, slug }): ReactNode => {
    const team = teamBySlug(slug)

    if (!team) return null

    return (
        <AppShell data={data} today={today ?? ''} title={team.name} description={team.description}>
            <PageHeader
                title={team.name}
                pill={(
                    <span className='caption-style bg-muted text-soft inline-flex shrink-0 items-center rounded-full border border-[#363636] px-2 py-[3px] tabular-nums'>
                        {team.members.length} members
                    </span>
                )}
            />
            <TeamView team={team} />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<TeamPageProps> = async ({ params }) => {
    const slug = typeof params?.slug === 'string' ? params.slug : ''

    if (!teamBySlug(slug)) return { notFound: true }

    return { props: { ...(await loadCrmPageProps()), slug } }
}

export default TeamPage
